import React, { useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { HomeContext } from '../../Context/HomeContext';
import { NavLink } from 'react-router-dom';
import { FaCalendarAlt, FaEye } from 'react-icons/fa';
import './ThreeSectionLayout.css';
import Loader from '../Loader';

const ThreeSectionRowLayout = () => {
  const { homeData, loading } = useContext(HomeContext);

  const trending = homeData?.trendingTopics || [];
  const todayBlogs = homeData?.todayTopBlogs || [];
  const featuredBlogs = homeData?.featuredBlogs || [];

  if (loading) {
    return <Loader text="Loading..." />;
  }
  

  const renderBlogItem = (item, index, type = 'blog') => {
    const title = item.title || item.name || 'Untitled';
    const date = item.published_at || item.created_at;
    const formattedDate = date ? new Date(date).toLocaleDateString() : 'Unknown date';
    const views = item.views_count !== undefined ? item.views_count : 'N/A';

    return (
      <NavLink
        to={`/${type === 'category' ? 'category' : 'blog'}/${item.slug}`}
        key={index}
        className="text-decoration-none text-white"
      >
        <div className="bg-black mb-3 p-2 rounded d-flex gap-2 blog-today-box">
          <img
            src={`https://api.funfillia.com/${item.image_500x500 || item.thumbnail || item.image_500x500}`}
            alt={title}
            className="blog-img-fixed rounded"
          />

          <div>
            <small className="text-warning">{item.category?.name || 'Category'}</small>
            <h6 className="mb-1 fw-semibold">
              {title.length > 50 ? title + '...' : title}
            </h6>

            {/* ✅ Only show date & views if not in Trending Topics */}
            {type !== 'category' && (
              <div className="small d-flex align-items-center gap-3">
                <span><FaCalendarAlt className="me-1" />{formattedDate}</span>
                <span><FaEye className="me-1" />{views}</span>
              </div>
            )}
          </div>
        </div>
      </NavLink>
    );
  };


  return (
    <Container fluid className="three-section-layout custom-width py-4 text-white">
      <Row className="gx-4 gy-5">
        {/* Trending Topics */}
        <Col lg={4} md={6} className="section-column">
          <h5 className="section-heading mb-3">Trending Topics</h5>
          {trending.slice(0, 5).map((item, idx) => renderBlogItem(item, idx, 'category'))}
        </Col>

        {/* Today Top Blogs */}
        <Col lg={4} md={6} className="section-column">
          <h5 className="section-heading mb-3">Today Top Blogs</h5>
          {todayBlogs.slice(0, 5).map((item, idx) => renderBlogItem(item, idx, 'blog'))}
        </Col>

        {/* Featured Blogs */}
        <Col lg={4} md={12} className="section-column">
          <h5 className="section-heading mb-3">Featured Posts</h5>
          {featuredBlogs.slice(0, 5).map((item, idx) => renderBlogItem(item, idx, 'blog'))}
        </Col>
      </Row>
    </Container>
  );
};

export default ThreeSectionRowLayout;
